import { AlertStatusValue } from 'src/atoms/filters/tariff-summary';
import { SortingParam } from 'src/common/components/Filters/constants/sorting';

type TariffSummaryQueriesListProps = {
  page: number;
  pageSize: number;
  accountRef: string | null;
  sorting: SortingParam;
  alertStatus: AlertStatusValue;
};

export const tariffSummaryQueries = {
  all: ['TariffSummary'],
  listAll: () => [...tariffSummaryQueries.all, 'List'],
  list: (filters: TariffSummaryQueriesListProps) => [...tariffSummaryQueries.listAll(), filters],
  lastUpdateTimestamp: () => [...tariffSummaryQueries.all, 'Last update timestamp'],
};
